import React from "react";
import { Spring } from 'react-spring/renderprops';
import "./Bannerimage.css";


export default function bannerimage() {
  return (
    <Spring
    from={{ opacity: 0}}
    to={{opacity: 1}}
        config={{ delay: 1000, duration: 1000}}
    >
      {props => (
        <div style={props}>
          {/* <div style={imgStyle}> */}

            <img className="imagestyle"  src="./assets/images/casion-display.png" alt=""/>
          {/* </div> */}
        </div>
      )}




      
    </Spring>
  );
}

// const imgStyle = {
//   padding: "10% 10% 10% 45%",
// //   '-webkit-box-shadow': 10px 10px 38px 0px rgba(0,0,0,0.75),
// // -moz-box-shadow: 10px 10px 38px 0px rgba(0,0,0,0.75),
// };
